import React, { Fragment, useState } from "react";
import Layout from "../../components/Layout/Layout";
import ViewUploadedMenu from "../../components/ViewUploadedMenu/ViewUploadedMenu";
import NewButton from "../../components/NewButton/NewButton";
import { EditAccess } from "./EditAccess";
import { SettingsAccount } from "./SettingsAccount";

import "./Settings.scss"

export default function Settings() {

  const [showEdit, setShowEdit] = useState(false);

  return (
    <Layout selectedIndex={5}>
      <div className="settings-container">
        <div className="settings-account container-header animated animatedFadeInUp fadeInUp">
          <span className="settings-account-title">Settings</span>
        </div>
        {showEdit
          ? (<div className="edit-access">
            <EditAccess />
          </div>)
          : (<div className="setting-content">
            <div className="ViewUploadedMenu-outline animated animatedFadeInUp fadeInUp">
              <ViewUploadedMenu tabValue={0} tabValueHandler={() => { }} array={["Account"]} />
            </div>
            <SettingsAccount />
          </div>)
        }
      </div>
    </Layout>
  );
}
